import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

function pushPageView() {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'virtualPageView',
  })
}

export default function useVirtualPageview() {
  const history = useHistory()
  const { pathname } = useLocation()
  const [lastPathname, setLastPathname] = useState(pathname)

  // push on initial page load
  useEffect(pushPageView, [])

  // push on subsequent route changes
  useEffect(() => {
    return history.listen(({ pathname }) => {
      if (pathname === lastPathname) {
        return
      }

      setLastPathname(pathname)
      pushPageView()
    })
  }, [history, lastPathname])
}
